/**
 * Loader.tsx which displays a loading spinner.
 * 
 * Author: Victor Chevillotte <victor.chevillotte@ircamamplify.com>
 * Copyright © Ircam amplify 2025
 */

import { LineWave } from 'react-loader-spinner'

export const Loader = () => {  
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginLeft:"60px" }}>
        <LineWave
          visible={true}
          height="200"
          width="200"
          color="#ee7e6b"
          ariaLabel="line-wave-loading"
          wrapperStyle={{}}
          wrapperClass=""
          firstLineColor=""
          middleLineColor=""
          lastLineColor=""
        />
      </div>
    );
  };
